import Wrapper from "../../../layout/Wrapper";
import VehicleBrandComponent from "../../../screens/settings/vehicle-brand";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Vehicle Brand",
	description: "",
};

export default function VehicleBrand() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<VehicleBrandComponent />
		</Wrapper>
	);
}